<template>
  <div class="container">
    <div class="d-flex fd-column ai-center">
      <p class="HEADING m-b-4 p-t-4:mo" selenium="preview-main-header">
        Almost done! Here is your review of {{ data.profileName }}.
      </p>
      <pro-avatar :image="data.profileLogo" :size="$device.isMobile ? 64 : 96" class="m-b-4" />
      <div class="d-flex m-b-4 p-l-6 p-r-6">
        <div
            v-for="(label, index) in $options.REVIEW_LABELS"
            :key="index"
            :class="['STAR', 'flex-1-1', 'm-0', {
              'PRESELECTED': index + 1 < data.overall_rating,
              'SELECTED': index + 1 === data.overall_rating,
            }]"
            @click="onRatingClick((index + 1), 'overall')">
          <vk-icon
              name="star"
              class="STAR-ICON"
              :selenium="'review-overall-star-' + (index + 1)" />
          <span class="text-sm" :selenium="'review-overall-label-' + label">{{ label }}</span>
        </div>
      </div>
    </div>

    <div class="MAXWIDTH p-l-2 p-r-2">
      <div class="m-b-4">
        <p class="COMMENTS m-b-1 p-l-1" selenium="preview-text-paragraph">
          {{data.review_comments}}
        </p>
        <div class="text-lg text-bold p-l-1" selenium="preview-user-fullname">
          – {{data.userFullName}}
        </div>
      </div>

      <div v-if="data.assets.length" class="m-b-4 d-flex fd-column ai-center">
        <gallery :files="data.assets"/>
        <p
            class="p-t-2 text-sm text-center">
          {{data.assets.length}} {{ data.assets.length === 1? 'photo' : 'photos'}} added
        </p>
      </div>

      <div class="m-b-4 CATEGORIES" v-if="data.categories">
        <review-categories :categories="data.categories" />
      </div>

      <div class="BUTTON-WRAPPER">
        <button
            class="BUTTON btn-secondary btn-sm btn-lg:t text-semibold"
            @click.prevent="onEdit"
            selenium="preview-edit">Edit</button>
        <button
            class="BUTTON btn btn-sm btn-lg:t text-semibold "
            @click.prevent="onSubmit"
            selenium="preview-submit">Submit Review</button>
      </div>
    </div>
  </div>
</template>

<script>
import reviewParams from '@/mixins/review-params';
import ProAvatar from '@/components/ProAvatar';
import Gallery from '@/components/Gallery/';
import ReviewCategories from '@/components/ReviewCategories';

export default {
  name: 'review-preview',
  components: {
    ProAvatar,
    Gallery,
    ReviewCategories,
  },
  mixins: [
    reviewParams,
  ],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onEdit () {
      this.$emit('hide-preview');
    },
    onSubmit () {
      this.$emit('submit-preview');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  $transition-half-duration: 0.15s;

  .HEADING {
    padding: 6*$unit 4*$unit 0;
    font-weight: 600;
    text-align: center;
    max-width: 700px;
    @include tablet {
      @include h3;
    }
  }

  .STAR {
    @include text-small;
    @include margin(0 0.5, 0 3);
    display: flex;
    flex-direction: column;
    width: 50px;
    align-items: center;
    color: $color-gray70;
    transition: font-weight $transition-half-duration;
    &.SELECTED {
      font-weight: 700;
    }
    &.PRESELECTED,
    &.SELECTED  {
      .STAR-ICON {
        color: $color-depot;
      }
    }
    .STAR-ICON {
      @include h4;
      margin-bottom: $unit;
    }
    @include tablet {
      @include h6;
    }
  }

  .COMMENTS {
    border-left: 4px solid lightgray;
  }

  .MAXWIDTH {
    max-width: 650px;
    margin: auto;
  }

  .CATEGORIES {
    max-width: 350px;
    margin: auto;
  }

  .BUTTON-WRAPPER {
    display: flex;
    margin: 2*$unit 2*$unit 4*$unit;
    BUTTON {
      flex-basis: 50%;
      margin: $unit;
    }
    @include tablet {
      margin: 2*$unit auto 4*$unit;
      max-width: 700px;
    }
  }
</style>
